import React from 'react';
import { Award, BookOpen, MessageSquare, ShoppingCart } from 'lucide-react';

const BonusSection: React.FC = () => {
  return (
    <section className="py-24 bg-[#c17c0c]/5 overflow-hidden relative">
      <div className="absolute top-1/2 left-1/2 -translate-x-1/2 -translate-y-1/2 w-[800px] h-[800px] bg-[#c17c0c]/10 blur-[150px] rounded-full pointer-events-none"></div>
      
      <div className="max-w-7xl mx-auto px-4 relative z-10">
        <div className="text-center mb-16">
          <span className="text-[#c17c0c] font-mono text-xs uppercase tracking-[0.4em]">Ecossistema Completo</span>
          <h2 className="text-3xl md:text-5xl font-bold mt-4 uppercase tracking-tighter italic">Muito além do <span className="text-[#c17c0c]">Software</span></h2>
        </div>

        <div className="grid grid-cols-1 lg:grid-cols-3 gap-8">
          <div className="bg-black/40 backdrop-blur-md p-10 border border-[#c17c0c]/20 rounded-3xl">
            <BookOpen className="text-[#c17c0c] mb-6" size={40} />
            <h3 className="text-2xl font-bold mb-4">Treinamento Especializado</h3>
            <p className="text-zinc-400 text-sm leading-relaxed mb-6">
              Acesso exclusivo à academia Guru.voto. Aprenda a ler os dados como um estrategista de elite. Treinamento prático de uso da ferramenta para você e sua equipe.
            </p>
            <div className="h-px bg-zinc-800 w-full"></div>
            <p className="mt-6 text-[10px] text-zinc-500 uppercase tracking-widest font-mono">Incluso para Membros</p>
          </div>

          <div className="bg-black/40 backdrop-blur-md p-10 border border-[#c17c0c]/20 rounded-3xl">
            <MessageSquare className="text-[#c17c0c] mb-6" size={40} />
            <h3 className="text-2xl font-bold mb-4">Consultoria Estratégica</h3>
            <p className="text-zinc-400 text-sm leading-relaxed mb-6">
              Não te entregamos apenas o mapa, te mostramos o caminho. Consultoria direta para interpretar cenários complexos e ajustar rotas táticas durante a pré-campanha.
            </p>
            <div className="h-px bg-zinc-800 w-full"></div>
            <p className="mt-6 text-[10px] text-zinc-500 uppercase tracking-widest font-mono">Disponibilidade Limitada</p>
          </div>

          <div className="bg-black/40 backdrop-blur-md p-10 border border-[#c17c0c]/20 rounded-3xl relative overflow-hidden group">
            <div className="absolute top-0 right-0 p-4">
              <div className="bg-[#c17c0c] text-black text-[8px] font-bold px-2 py-1 rounded-full uppercase tracking-widest">Bônus VIP</div>
            </div>
            <ShoppingCart className="text-[#c17c0c] mb-6" size={40} />
            <h3 className="text-2xl font-bold mb-4">Área de Suprimentos</h3>
            <p className="text-zinc-400 text-sm leading-relaxed mb-6">
              Apoio direto na escolha e aquisição das melhores alternativas de material de campanha. Curadoria de fornecedores e otimização de custos de produção.
            </p>
            <div className="h-px bg-zinc-800 w-full"></div>
            <p className="mt-6 text-[10px] text-zinc-500 uppercase tracking-widest font-mono">Vantagem Competitiva</p>
          </div>
        </div>
      </div>
    </section>
  );
};

export default BonusSection;